import fetch from '../../utils/fetch'

export function getRecordByTaskId(params) {
    return fetch({
        url: '/api/bussinessCoupon/wxBusinessTaskSendRecord',
        method: 'GET',
        params
    })
}
